<template>
    <div class="blank-space">
        <span>&nbsp;</span>
    </div>
</template>
  
<script>
/* eslint-disable */
import { mapMutations } from 'vuex'
import UserApi from '@/api/identityProvider/user'

export default {
    data(){
        return {
            uniqueId: `${self._uid}-callback`
        }
    },
    async mounted(){
        this.setLoaderText(this.$t("Common.gattering-login-information"));
        this.setLoaderQueue(this.uniqueId);

        const userInfo = await this.$security.signinRedirectCallback();
        const user = await UserApi.listById(userInfo.profile.sub);        

        if(user.success) {
            this.setUser(user.data);
            this.setUserName(user.data.username);
        }

        this.clearLoaderQueue();
        this.setLoaderText(null);
        this.$router.push("/");       
    },  
    methods:{
        ...mapMutations("app", ["setLoaderQueue", "setLoaderText", "clearLoaderQueue", "setUser", "setUserName"]), 
    },    
}
</script>

<style lang="scss" scoped>
@import "../../styles/material-dashboard/variables";

div{
    display: block;
    height: 700px;
    color: $body-color;
}
</style>
